import { render, staticRenderFns } from "./ChukuReceipts.vue?vue&type=template&id=4ce26234&scoped=true&"
import script from "./ChukuReceipts.vue?vue&type=script&lang=js&"
export * from "./ChukuReceipts.vue?vue&type=script&lang=js&"
import style0 from "./ChukuReceipts.vue?vue&type=style&index=0&id=4ce26234&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce26234",
  null
  
)

export default component.exports